import React, { Component, useState } from "react";
import { Grid2 as Grid, Typography } from "@mui/material";
import { useNavigate, withRouter } from "react-router-dom";
import { styled } from "@mui/material/styles";

const PREFIX = "OpsPage";
const classes = {
  tileGrid: `${PREFIX}-tileGrid`,
  imageStyle: `${PREFIX}-imageStyle`,
  tileTitleStyle: `${PREFIX}-tileTitleStyle`,
  readTextGrid: `${PREFIX}-readTextGrid`,
  subTextStyle: `${PREFIX}-subTextStyle`,
  linkTextStyle: `${PREFIX}-linkTextStyle`,
  titleContainer: `${PREFIX}-titleContainer`,
  cardTextGrid: `${PREFIX}-cardTextGrid`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.tileGrid}`]: {
    display: "flex",
    margin: "auto",
    maxWidth: "17rem",
    height: "20rem",
    borderRadius: "1.5rem",
    flexDirection: "column",
    alignItems: "center",
    padding: "1.4em",
    boxShadow: "5px 5px 19px 0px rgba(199, 199, 199)",
    cursor: "pointer",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  [`& .${classes.imageStyle}`]: {
    display: "flex",
    justifyContent: "center",
    objectFit: "contain",
    height: "50%",
    width: "100%",
  },
  [`& .${classes.tileTitleStyle}`]: {
    fontSize: 18,
    padding: "0.5em 0 0.5rem 0",
    fontWeight: 600,
    textAlign: "center",
  },
  [`& .${classes.readTextGrid}`]: {
    display: "flex",
    justifyContent: "center",
  },
  [`& .${classes.subTextStyle}`]: {
    fontSize: 12,
    color: "grey",
    textAlign: "center",
  },
  [`& .${classes.linkTextStyle}`]: {
    fontSize: 16,
    color: "#fa1414",
    paddingTop: "1rem",
    textAlign: "center",
    width: "100%",
  },
  [`& .${classes.titleContainer}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  [`& .${classes.cardTextGrid}`]: {
    width: "100%",
    justifyContent: "center",
  },
}));

const BlogTile = ({ blogData }) => {
  const navigate = useNavigate();
  const handleTileClick = (blogData) => {
    navigate(`/blog/${blogData.title}`, { state: { blog: blogData } });
  };

  return (
    <StyledGrid className="tileWrapper" container>
      <Grid size={{ xs: 12 }} className={classes.titleContainer}>
        {blogData &&
          blogData.map((item) => {
            const imageUrl = item.thumbnailImageTitle;
            return (
              <Grid
                key={item.title}
                className={classes.tileGrid}
                onClick={() => handleTileClick(item)}
              >
                <img
                  src={imageUrl}
                  alt={item.title}
                  className={classes.imageStyle}
                />
                <Typography className={classes.tileTitleStyle}>
                  {item.title}
                </Typography>
                <Grid container className={classes.cardTextGrid}>
                  <Grid size={{ xs: 6 }}>
                    <Typography className={classes.subTextStyle}>
                      Author
                    </Typography>
                    <Typography className={classes.subTextStyle}>
                      {item.author}
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Typography className={classes.subTextStyle}>
                      Published
                    </Typography>
                    <Typography className={classes.subTextStyle}>
                      {item.publishDate}
                    </Typography>
                  </Grid>
                </Grid>
                <span className={classes.linkTextStyle}>Read more</span>
              </Grid>
            );
          })}
      </Grid>
    </StyledGrid>
  );
};

export default BlogTile;
